import ControlHubsIcon from "../../assets/product-list-assets/control-hubs.svg";
import type { ProductListGroup } from "../../types";

export const controlHubs: ProductListGroup = {
  id: "controlHubs",
  title: "productListGroup.controlHubs.title",
  icon: {
    src: ControlHubsIcon,
    width: 20,
    height: 20,
  },
};
